import React from "react";
import Style from "../style/sidebar.module.scss";

const menuItems = [
  { path: "/", label: "Home", icon: "fa-house" },
  { path: "/about-us", label: "About us", icon: "fa-user" },
  { path: "/listings", label: "Listing", icon: "fa-rectangle-list" },
  { path: "/contact", label: "Contact", icon: "fa-address-card" },
  { path: "/blog", label: "Blog", icon: "fa-blog" },
];

export interface IType {
  handleNav: any;
}

const Sidebar: React.FC<IType> = ({ handleNav }) => {
  return (
    <div className={Style.content}>
      <h2>
        Menu<span onClick={handleNav}>X</span>
      </h2>
      <ul>
        {menuItems.map((item, index) => (
          <li key={index}>
            <a href={item.path}>
              <i className={`fa-solid ${item.icon}`}></i> {item.label}
              <span className={Style.arrow}>→</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
